module.exports = __webpack_public_path__ + "static/media/shoppingCartWhiteOutlined.a222d275.svg";